import { ChangeDetectorRef, Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';

import { ToasterService } from 'src/app/core/framework/toaster/toaster.service';
import { RelatorioComponent } from '../../relatorio.component';
import { BreadcrumbService } from 'src/app/core/framework/breadcrumb.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-relatorio-base',
  templateUrl: './relatorio-base.component.html',
  styleUrls: ['./relatorio-base.component.css']
})
export class RelatorioBaseComponent<M, F> implements OnInit {

  acao: 'formulario' | 'relatorio' = 'formulario';
  formDisabled = true;

  public relatorioBase: TemplateRef<any> = null;

  @Input() public nome = '';
  @Input() public controller: any;

  @ViewChild('appRelatorio') public appRelatorio: RelatorioComponent<M, F>;

  
  constructor(
    private toasterService: ToasterService
    , private changeDetectorRef: ChangeDetectorRef
    , private breadcrumbService: BreadcrumbService
    , private location: Location
  ) {
  }

  public setRelatorioBase(templateRef: TemplateRef<any>): void {
    this.relatorioBase = templateRef;
    this.changeDetectorRef.detectChanges();
  }

  carregarRelatorio(pagina?: number): void {
    if ( this.controller?.carregarRelatorio ) {
      this.controller.carregarRelatorio(pagina);
    }
    else {
      this.toasterService.error('Ocorreu um erro na operação', 'Relatorio Controller não foi declarado.');
    }
  }

  ngOnInit(): void {
    this.configurarBreadcrumb();
  }

  private configurarBreadcrumb(): void {
    this.breadcrumbService.setMenuConfig(
      this.breadcrumbService
          .getMenuConfig()
          .hideAll()
          .setExtraButtons([
          {
            mat_icon: 'description',
            command: () => {
              console.log('exportar');
            },
            visible: true
          }, {
              mat_icon: 'arrow_back'
              , command: () => {
                if ( this.acao === 'formulario' ) {
                  this.location.back();
                }
                else {
                  this.acao = 'formulario';
                  this.appRelatorio.limparResultado();
                }
              }
              , visible: !environment.production
          }
        ])
    );    
  }

}
